import { SVGProps } from "react";

const TrophyIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.22034 4.67297C5.96918 4.67297 6.57627 5.28006 6.57627 6.02891V10.0967C6.57627 13.0921 9.00454 15.5204 12 15.5204C14.9954 15.5204 17.4237 13.0922 17.4237 10.0967V6.02891C17.4237 5.28006 18.0308 4.67297 18.7797 4.67297H5.22034Z"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.30186 12.8086C5.40342 12.8086 4 11.2696 4 9.37116V7.38489H6.57627"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4237 7.38489H20V9.37116C20 11.2696 18.5966 12.8086 16.6981 12.8086"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7119 18.2323H9.28818L7.93225 20.673H16.0678L14.7119 18.2323Z"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.5204V18.2323"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.4526C12.7488 11.4526 13.3559 10.8455 13.3559 10.0967C13.3559 9.34779 12.7488 8.74072 12 8.74072C11.2511 8.74072 10.644 9.34779 10.644 10.0967C10.644 10.8455 11.2511 11.4526 12 11.4526Z"
        stroke="currentColor"
        strokeWidth="1.69492"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrophyIcon;
